import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { QuotesNotes } from "../models/qoutes/quotesNotes";

@Injectable({
  providedIn: "root",
})
export class QuoteNotesSidebarService {
  private quoteManagementBaseURL = environment.baseUrl + "/QuotesManagement";
  private saleOrderManagementBaseURL =
    environment.baseUrl + "/SalesOrderManagement";
  constructor(private _http: HttpClient) {}

  AddQuoteNotes(payload: QuotesNotes): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.quoteManagementBaseURL + "/AddQuotesNotes",
      payload
    );
  }

  getAllLinePoNumber(
    saleOrderId: string
  ): Observable<GenericResponseDto<string[]>> {
    return this._http.get<GenericResponseDto<string[]>>(
      this.saleOrderManagementBaseURL +
        `/GetPurchaseOrderIdOfSalesOrder?SaleOrderId=` +
        saleOrderId
    );
  }

  deleteSalesOrderNotes(
    payload: number[]
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.saleOrderManagementBaseURL + "/DeleteSalesOrderNotes",
      payload
    );
  }

  AddSalesOrderNotes(
    payload: QuotesNotes
  ): Observable<GenericResponseDto<boolean>> {
    return this._http.post<GenericResponseDto<boolean>>(
      this.saleOrderManagementBaseURL + "/AddSalesOrderNotes",
      payload
    );
  }
}
